import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/auth/PrivateRoute';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import Dashboard from './pages/Dashboard';
import AgentLibrary from './pages/AgentLibrary';
import AgentBuilder from './pages/AgentBuilder';
import ScenarioLibrary from './pages/ScenarioLibrary';
import ScenarioBuilder from './pages/ScenarioBuilder';
import SimulationRunner from './pages/SimulationRunner';
import SimulationList from './pages/SimulationList';
import Results from './pages/Results';
import AnalyticsDashboard from './pages/AnalyticsDashboard';
import Benchmark from './pages/Benchmark';
import Profile from './pages/Profile';
import Corpus from './pages/Corpus';
import VerifyEmail from './pages/VerifyEmail';
import Settings from './pages/Settings';
import PracticeHome from './pages/practice/PracticeHome';
import PracticeSession from './pages/practice/PracticeSession';
import PracticeReport from './pages/practice/PracticeReport';
import PracticeHistory from './pages/practice/PracticeHistory';
import Upgrade from './pages/Upgrade';
import UpgradeSuccess from './pages/UpgradeSuccess';
import UpgradeCancel from './pages/UpgradeCancel';
import Home from './pages/Home';
import Pricing from './pages/Pricing';
import Developer from './pages/Developer';
import RestApiDocs from './pages/RestApiDocs';
import TermsOfUse from './pages/TermsOfUse';
import PrivacyPolicy from './pages/PrivacyPolicy';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/signup" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Navigate to="/signup" replace />} />
          <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
          <Route path="/agents" element={<PrivateRoute><AgentLibrary /></PrivateRoute>} />
          <Route path="/agents/new" element={<PrivateRoute><AgentBuilder /></PrivateRoute>} />
          <Route path="/agents/:id" element={<PrivateRoute><AgentBuilder /></PrivateRoute>} />
          <Route path="/scenarios" element={<PrivateRoute><ScenarioLibrary /></PrivateRoute>} />
          <Route path="/scenarios/new" element={<PrivateRoute><ScenarioBuilder /></PrivateRoute>} />
          <Route path="/scenarios/:id" element={<PrivateRoute><ScenarioBuilder /></PrivateRoute>} />
          <Route path="/simulations" element={<PrivateRoute><SimulationList /></PrivateRoute>} />
          <Route path="/simulations/new" element={<PrivateRoute><SimulationRunner /></PrivateRoute>} />
          <Route path="/results" element={<PrivateRoute><SimulationList /></PrivateRoute>} />
          <Route path="/results/:id" element={<PrivateRoute><Results /></PrivateRoute>} />
          <Route path="/analytics" element={<PrivateRoute><AnalyticsDashboard /></PrivateRoute>} />
          <Route path="/benchmark" element={<PrivateRoute><Benchmark /></PrivateRoute>} />
          <Route path="/practice" element={<PrivateRoute><PracticeHome /></PrivateRoute>} />
          <Route path="/practice/session/:id" element={<PrivateRoute><PracticeSession /></PrivateRoute>} />
          <Route path="/practice/report/:id" element={<PrivateRoute><PracticeReport /></PrivateRoute>} />
          <Route path="/practice/history" element={<PrivateRoute><PracticeHistory /></PrivateRoute>} />
          <Route path="/profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
          <Route path="/settings" element={<PrivateRoute><Settings /></PrivateRoute>} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/corpus" element={<PrivateRoute><Corpus /></PrivateRoute>} />
          <Route path="/upgrade" element={<PrivateRoute><Upgrade /></PrivateRoute>} />
          <Route path="/upgrade/success" element={<PrivateRoute><UpgradeSuccess /></PrivateRoute>} />
          <Route path="/upgrade/cancel" element={<PrivateRoute><UpgradeCancel /></PrivateRoute>} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/developer" element={<PrivateRoute><Developer /></PrivateRoute>} />
          <Route path="/api-docs" element={<RestApiDocs />} />
          <Route path="/terms" element={<TermsOfUse />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
